import api from '@/api';
import Plant from '@/models/plant';

export async function list(): Promise<Array<Plant>> {
  const { data } = await api.get('plants');
  return data;
}

export async function getById(id: number): Promise<Plant> {
  const { data } = await api.get(`plants/${id}`);
  return data;
}

export async function create(plant: Plant): Promise<Plant> {
  const { data } = await api.post(`plants`, plant);
  return data;
}

export async function update(id: number, plant: Plant): Promise<Plant> {
  const { data } = await api.put(`plants/${id}`, plant);
  return data;
}

export async function remove(id: number): Promise<void> {
  await api.delete(`plants/${id}`);
}
